module.exports = __webpack_public_path__ + "toyota.322f0e66df757274ffff.png";